import {MY_TEAM_ADD_USER, MY_TEAM_ALL_ROLES,MY_TEAM_ALL_ROLES_SUCCESSFUL, MY_TEAM_ADD_USER_SUCCESSFUL, MY_TEAM_ADD_USER_FAILED} from "./actionTypes"

export const getAllRoles = () =>{
    return {
        type: MY_TEAM_ALL_ROLES
    }
}
export const getAllRolesSuccessful = (allRoles) =>{
    return {
        type: MY_TEAM_ALL_ROLES_SUCCESSFUL,
        payload: {allRoles}
    }
}


export const addUser = (newUserMyTeam) =>{
    return {
        type: MY_TEAM_ADD_USER,
        payload: {newUserMyTeam}
    }
}

export const addUserSuccessful = (message) =>{
    return {
        type: MY_TEAM_ADD_USER_SUCCESSFUL,
        payload:{message}
    }
}

export const addUserFailed = (message) =>{
    return {
        type: MY_TEAM_ADD_USER_FAILED,
        payload:{message}
    }
}